<template>
<div class="visibility">
    <v-container>
        <v-layout row wrap>
            <v-flex xs12>
                <v-flex tag="h2">{{myVisibilityConstants.MYVISIBILITY}}</v-flex>
            </v-flex>
            <v-flex xs12 class="alert__box__success" v-if="success">
                    <v-icon>check</v-icon> <span style="margin-left:30px;">{{confirmationMessage}}</span>
            </v-flex>
            <v-flex xs12 class="alert__box__failure" v-if="error">
                <v-icon>check</v-icon> <span style="margin-left:30px;">{{myVisibilityConstants.SAVE_WARNING}}</span>
            </v-flex>
            <v-flex xs12 sm5>
                <v-flex class="options">
                    <v-flex tag="h3">{{myVisibilityConstants.MY_ONLINES_STATUS}}</v-flex>
                    <v-flex tag="h4">{{myVisibilityConstants.INDICATE_WHEN_I_AM_ONLINE}}</v-flex>
                    <v-flex xs12>
                        <v-select v-model="visibilityInformation.indicateWhenIAmOnline" 
                                :items="items" 
                                item-text="text" 
                                item-value="value"
                                data-qe-id="myVisibilityStatusDropdown"
                                return-object v-on:change="changeOnlineStatus($event)">
                        </v-select>
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 class="footer" text-xs-center>
                <v-btn class="primary_btn transparent" @click="cancel()" data-qe-id="statusChange_cancelBtn">{{appCommonConstants.CANCEL}}</v-btn>
                <v-btn class="primary_btn" :disabled="isDisabled" @click="submitVisibilitySettings()" data-qe-id="statusChange_saveBtn">{{appCommonConstants.SAVE}}</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { storeAction } from '../../store/storeActions.constant';
import { storeGetters } from '../../store/storeGetters.constant';
import { myVisibilityConstants } from "./privacysettings.constants.js";
import { appCommonConstants } from "../appCommon.constants.js";

export default {
    name: "MyVisibility",
    data: () => ({
        myVisibilityConstants,
        appCommonConstants,
        confirmationMessage: '',
        isDisabled: true,
        success: false,
        error: false,
        items: [
            { text: "Show All Members", value: 0 },
            { text: "Show only my YPO Connections", value: 1 },
            { text: "Show no one", value: 2 },
        ],
    }),
    created() {
        this.getVisibilityInformation();
    },
    methods: {
        ...mapActions({
            getVisibilityInformation: `myAccount/${storeAction.getVisibilityInformation}`,
            saveVisibilitySettings: `myAccount/${storeAction.saveVisibilityPreferences}`,
        }),
        cancel() {
            this.getVisibilityInformation();
            this.isDisabled = true;
        },
        changeOnlineStatus(indicateWhenIAmOnline) {
            this.isDisabled = false;
            this.visibilityInformation.indicateWhenIAmOnline = indicateWhenIAmOnline.value;
        },
        submitVisibilitySettings() {
            this.visibilityInformation.indicateWhenIAmOnline = this.visibilityInformation.indicateWhenIAmOnline.value;
            this.saveVisibilitySettings(this.visibilityInformation)            
            .then(() => {
                this.isDisabled = true;
                this.success = true;
                if (this.success) {
                    if (this.visibilityInformation.indicateWhenIAmOnline === 2) {
                        this.confirmationMessage = this.myVisibilityConstants.SHOW_NO_ONE_CONFIRMATION;
                    } else {
                        this.confirmationMessage = this.myVisibilityConstants.OTHER_CONFIRMATION;
                    }
                }
            })
            .catch(() => {               
                this.error = true;
                this.isDisabled = true;
        });
        },
    },
    computed: {
        ...mapGetters({
            visibilityInformation: `myAccount/${storeGetters.visibilityInformation}`,
        }),      
    },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";

.visibility {
    background: $white;

    .alert__box {
        &__success {
            background: $ypo-gold;
            color: $white;
            position: relative;
            padding: 10px 10px 10px 45px;
            font-size: 12px;
            text-transform: initial;
            line-height: normal;
            margin-bottom: 13px;
            margin-top: 0px;

            i {
            font-size: 28px !important;
            color: $white !important;
            position: absolute;
            left: 40px;
            top: 0;
            bottom: 0;
            }
        }

        &__failure {
            background: $ypo-red;
            color: $white;
            position: relative;
            padding: 10px 10px 10px 45px;
            font-size: 12px;
            text-transform: initial;
            line-height: normal;
            margin-bottom: 13px;
            margin-top: 0px;

            i {
            font-size: 28px !important;
            color: $white !important;
            position: absolute;
            left: 40px;
            top: 0;
            bottom: 0;
            }
        }
    }
    h2 {
        color: $ypo-blue;
        font-family: Raleway;
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 20px 0;
    }

    h3 {
        color: $ypo-blue;
        font-family: "Noto Sans";
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid $ypo-medium-gray;
        margin: 0 0 15px 0;
    }

    h4 {
        font-size: 14px;
        color: $ypo-blue;
        margin-bottom: 10px;
    }

    .options {
        margin-bottom: 15px;
    }
@media (max-width: 767px){
    margin-top: 0 !important;
    padding: 10px 20px;
    h2 {
        font-size: 18px;
        font-weight: 500;
    }
    h3 {
        font-size: 14px;
    }
    .footer {
        background: none;
        text-align: right !important;
        padding: 0;
        margin: 20px 0 70px 0;
    }
}    
}

.footer {
    background-color: $ypo-tile-border;
    position: absolute;
    left: 0;
    right: 0;
    padding: 20px 10px;
    margin-top: 30px;
}
</style>
